import {useCallback} from 'react';

import {$invoiceLinesHolder, updateInvoiceLinesHolder} from '../../models/create';
import {getRowAtPath} from '../../models/create/init';

import {isStandartCategory} from '../helpers/consts';

const checkIfNumber = (values: string[], depthId: string, name: string) => {
    if (values.some((i) => i === undefined)) {
        updateInvoiceLinesHolder({
            depth: {step: 0, id: depthId},
            data: {columnId: name, value: ''},
        });
        return false;
    }

    if (values.some((i) => isNaN(Number(i)))) {
        updateInvoiceLinesHolder({
            depth: {step: 0, id: depthId},
            data: {columnId: name, value: ''},
        });
        return false;
    }

    return true;
};

export const useLineCalculations = () => {
    const combineValues = useCallback((depthId: string | undefined) => {
        if (depthId === undefined) {
            return;
        }
        const currentHolder = $invoiceLinesHolder.getState();

        const item = getRowAtPath(currentHolder, depthId);

        if (!item) {
            return;
        }
        const {qty, price} = item;
        const name = 'lines';

        if (!price || !qty) {
            return;
        }

        if (!checkIfNumber([price.toString(), qty.toString()], depthId, name)) {
            return;
        }

        const multiplier = item.charges?.isCharge === 'true' ? 1 : -1;
        const xaf = item.charges?.amountXaf ? Number(item.charges.amountXaf) * multiplier : 0;
        const mutiplie = !price || !qty ? '' : (Number(price) * Number(qty) + xaf).toFixed(2);
        updateInvoiceLinesHolder({
            depth: {step: 0, id: depthId},
            data: {columnId: name, value: mutiplie},
        });
    }, []);

    const calculateLineAmountWVat = useCallback(
        (depthId: string | undefined, columnId?: 'vatCategory' | 'vat') => {
            if (depthId === undefined) {
                return;
            }
            const currentHolder = $invoiceLinesHolder.getState();
            const item = getRowAtPath(currentHolder, depthId);
            if (!item) {
                return;
            }

            const {vat, lines, vatCategory} = item;
            const name = 'lineAmountWVat';

            if (columnId === 'vatCategory') {
                updateInvoiceLinesHolder({
                    depth: {step: 0, id: depthId},
                    data: [
                        {
                            columnId: 'vat',
                            value: isStandartCategory(vatCategory?.value) ? '' : '0',
                        },
                        {
                            columnId: 'lineAmountWVat',
                            value: isStandartCategory(vatCategory?.value)
                                ? ''
                                : Number(lines).toFixed(2),
                        },
                    ],
                });
                return;
            }

            if (!vat) {
                return;
            }

            if (!checkIfNumber([vat], depthId, name)) {
                return;
            }

            const mutiplie =
                !lines || !vat
                    ? ''
                    : (Number(lines) + (Number(lines) * Number(vat)) / 100).toFixed(2);
            updateInvoiceLinesHolder({
                depth: {step: 0, id: depthId},
                data: {columnId: name, value: mutiplie},
            });
        },
        [],
    );

    return {
        combineValues,
        calculateLineAmountWVat,
    };
};
